<template>
  <div class="description-content">
    <div class="main-container">
      <div class="text desc1">
        {{ $t("views.desc_1") }}
        <a :href="desc1_Url">{{ $t("views.desc_2") }}</a>
      </div>
      <div class="text">
        <span class="symbol">*</span>
        {{ $t("views.desc_3") }}
      </div>
      <div class="website-wrap">
        <img class="lock" src="../assets/images/lock.png" />
        <div class="website">
          <img class="unlock" src="../assets/images/unlock.png" />
          <span class="text">https://www.tokenpocket.pro/</span>
        </div>
      </div>
      <div class="text">
        <span class="symbol">*</span>
        {{ $t("views.desc_4") }}
      </div>
      <div class="text desc2">
        <span class="symbol">* </span>
        <a :href="desc5_Url">{{ $t("views.desc_5") }}</a>
      </div>
    </div>
    <div class="version-content" v-if="platform">
      <div class="left" @click="$modal.show('version-panel')">
        <img src="../assets/images/add-icon.png" />
        <div class="text" v-if="versionData.version">
          <span style="font-weight:bold">{{ $t("views.verifyText") }}</span>
          <span>v{{ versionData.version }}</span>
        </div>
        <div
          class="text"
          v-else-if="androidVersion.version !== googlePlayVersion.version"
        >
          <div style="font-weight:bold">{{ $t("views.verifyText2") }}</div>
          <div>Android APK v{{ androidVersion.version }}</div>
          <div>Google Play v{{ googlePlayVersion.version }}</div>
        </div>
        <div class="text" v-else>
          <span style="font-weight:bold">{{ $t("views.verifyText") }}</span>
          <span>v{{ androidVersion.version }}</span>
        </div>
      </div>
      <a :href="verify_Url" class="text">{{ $t("views.verifyText1") }}</a>
    </div>
    <modal
      v-if="platform"
      name="version-panel"
      classes="version-wrap"
      height="auto"
      width="95%"
    >
      <div class="version-title" v-if="androidVersion.version">
        {{ $t("views.verifyText") }} v{{ androidVersion.version }}
      </div>
      <div class="android-APK" v-if="androidVersion.version">
        <div class="name">Android APK SHA256</div>
        <div class="name hash">{{ androidVersion.sha256 }}</div>
        <div class="name">Android APK md5</div>
        <div class="name hash">{{ androidVersion.md5 }}</div>
      </div>
      <div
        class="version-title version-title2"
        v-if="googlePlayVersion.version"
      >
        {{ $t("views.verifyText3") }} v{{ googlePlayVersion.version }}
      </div>
      <div class="android-APK" v-if="googlePlayVersion.version">
        <div class="name">Google Play SHA256</div>
        <div class="name hash">{{ googlePlayVersion.sha256 }}</div>
        <div class="name">Google Play md5</div>
        <div class="name hash">{{ googlePlayVersion.md5 }}</div>
      </div>
      <img
        src="../assets/images/extension-close.png"
        @click="$modal.hide('version-panel')"
      />
    </modal>
  </div>
</template>

<script>
import Platform from "../platform";

export default {
  data() {
    return {
      platform: undefined
    };
  },
  props: {
    versionData: {
      type: Object
    },
    androidVersion: {
      type: Object
    },
    googlePlayVersion: {
      type: Object
    }
  },
  computed: {
    desc1_Url() {
      if (this.$i18n.locale === "zh") {
        return "https://help.tokenpocket.pro/cn/TokenPocket-product-policy-adjustment-instructions";
      } else {
        return "https://help.tokenpocket.pro/en/announcement/TokenPocket-product-policy-adjustment-instructions";
      }
    },
    desc5_Url() {
      if (this.$i18n.locale === "zh") {
        return "https://help.tokenpocket.pro/cn/secirity-knowledge/fraud-cases";
      } else {
        return "https://help.tokenpocket.pro/en/security-knowledge/common-fraud-cases";
      }
    },
    verify_Url() {
      if (this.$i18n.locale === "zh") {
        return "https://help.tokenpocket.pro/cn/secirity-knowledge/protective-measures/verification";
      } else {
        return "https://help.tokenpocket.pro/en/security-knowledge/security-measure/verify";
      }
    }
  },
  created() {
    this.platform = Platform.isAndroid;
  }
};
</script>

<style lang="scss">
.description-content {
  margin: 0 0.32rem;
  margin-bottom: 1rem;
  background: #f0f4ff;
  border-radius: 0.12rem;
  .text {
    font-size: 0.24rem;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #666666;
    line-height: 0.33rem;
  }
  a {
    text-decoration: none;
    color: #2980fe;
  }
  .main-container {
    // padding: 0.2rem;
    padding: 0.3rem 0.36rem;
    background: #f0f4ff;
    border-radius: 0.12rem 0.12rem 0 0;
    .symbol {
      color: #e55036;
    }
    .desc1 {
      font-size: 0.26rem;
      color: #333333;
      margin-bottom: 0.21rem;
    }
    .website-wrap {
      margin: 0.21rem 0;
      display: flex;
      align-items: center;
      .lock {
        width: 0.4rem;
        height: 0.33rem;
      }
      .website {
        margin-left: 0.1rem;
        padding-right: 0.5rem;
        height: 0.44rem;
        background: #ffffff;
        border: 0.01rem solid #d7d7d7;
        border-radius: 0.23rem;
        display: flex;
        align-items: center;
        .unlock {
          margin-left: 0.05rem;
          width: 0.36rem;
          height: 0.33rem;
        }
        span {
          margin-left: 0.16rem;
          font-size: 0.22rem;
          color: #333333;
        }
      }
    }
  }
  .version-content {
    padding: 0.2rem 0.3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 0.01rem solid #fff;
    .left {
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        margin-right: 0.1rem;
        width: 0.24rem;
        height: 0.24rem;
      }
      div {
        // width: 2.04rem;
        font-size: 0.2rem;
      }
    }
    a {
      width: 2.04rem;
      color: #2980fe;
      font-size: 0.2rem;
    }
  }
}

.version-wrap {
  background: #ffffff;
  border-radius: 0.24rem;
  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.25);
  padding: 0.6rem 0.55rem;
  .version-title {
    font-size: 0.28rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 700;
    text-align: left;
    color: #333333;
  }
  .version-title2 {
    margin-top: 0.2rem;
  }
  .android-APK {
    margin-top: 0.2rem;
    .name {
      margin-top: 0.08rem;
      font-size: 0.24rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 700;
      text-align: left;
      color: #333333;
      line-height: 0.33rem;
    }
    .hash {
      word-break: break-all;
      font-weight: 500;
      font-family: PingFangSC, PingFangSC-Regular;
    }
  }
  img {
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    width: 0.24rem;
    height: 0.24rem;
    cursor: pointer;
  }
}
</style>
